import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function Wysiwyg({ initialValue, onBlur, height = 500 }) {
  const [value, setValue] = useState(initialValue || '');
  const lastSavedRef = useRef(value);

  const didInit = useRef(false);
  useEffect(() => {
    if (!didInit.current) {
      setValue(initialValue || '');
      lastSavedRef.current = initialValue || '';
      didInit.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue]);

  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline'],
        [{ color: [] }, { background: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link', 'image'],
        ['clean'],
      ],
    }),
    []
  );

  const formats = useMemo(
    () => ['header', 'bold', 'italic', 'underline', 'color', 'background', 'list', 'bullet', 'link', 'image'],
    []
  );

  function toClassHighlight(html) {
    if (!html || typeof document === 'undefined') return html;
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    // find spans that have any background-related inline style
    const spans = tmp.querySelectorAll('span[style]');
    spans.forEach((el) => {
      const style = (el.getAttribute('style') || '').toLowerCase();
      if (style.includes('background-color') || style.includes('background:')) {
        el.classList.add('highlight');
      }
    });
    return tmp.innerHTML;
  }

  const handleBlur = useCallback(
    (previousRange, source, editor) => {
      if (source === 'silent') return;
      const raw = editor.getHTML();
      const html = toClassHighlight(raw);
      if (html === lastSavedRef.current) return;

      requestAnimationFrame(() => {
        lastSavedRef.current = html;
        onBlur(html);
      });
    },
    [onBlur]
  );

  return (
    <div style={{ marginBottom: '60px' }}>
      <ReactQuill
        key='quill'
        value={value}
        onChange={(content) => setValue(content)}
        onBlur={handleBlur}
        style={{ height }}
        modules={modules}
        formats={formats}
      />
    </div>
  );
}

export default Wysiwyg;
